import _isNil from 'lodash/isNil'
import { ServiceError } from './ServiceError'

export type TokenProvider = () => string | null | undefined

const TOKEN_PROVIDER_NOOP: TokenProvider = () => {
    return undefined
}

export class ServiceClient {

    private tokenProvider = TOKEN_PROVIDER_NOOP

    setTokenProvider(provider: TokenProvider) {
        this.tokenProvider = provider
    }

    newUrl(path: string) {
        return new URL(location.origin + path)
    }

    async get<T>(url: URL | string) {
        const response = await fetch(url, { method: 'GET' })
        return (await getBody(response, 200)) as T
    }

    async authGet<T>(url: URL | string) {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${this.getAccessToken()}`
            }
        })
        return (await getBody(response, 200)) as T
    }

    async post<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {}
        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        if (!_isNil(requestBody)) {
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 201)) as T
    }

    async queryPost<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {}
        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        if (!_isNil(requestBody)) {
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 200)) as T
    }

    async authPost<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 201)) as T
    }

    async authQueryPost<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 200)) as T
    }

    async authPut<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'PUT', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 200)) as T
    }

    async authPostTextBody<T>(url: URL | string, requestBody?: string) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'text/plain;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 201)) as T
    }

    async delete<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {}
        const cfg: RequestInit = { method: 'DELETE', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        if (!_isNil(requestBody)) {
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 200)) as T
    }

    async authDelete<T>(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'DELETE', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        const response = await fetch(url, cfg)
        return (await getBody(response, 200)) as T
    }

    async authRawPost(url: URL | string, requestBody?: unknown) {
        const headers: HeadersInit = {
            Authorization: `Bearer ${this.getAccessToken()}`
        }

        const cfg: RequestInit = { method: 'POST', headers }

        if (!_isNil(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8'
            cfg.body = JSON.stringify(requestBody)
        }

        return fetch(url, cfg)
    }

    private getAccessToken() {
        const accessToken = this.tokenProvider()
        if (!accessToken) {
            throw new ServiceError(401, 'Unauthorized')
        }
        return accessToken
    }
}

export default new ServiceClient()

async function getBody(response: Response, checkStatusCode: number) {
    type BodyError = {
        statusCode?: number
        message?: string
    }

    const body: unknown = await response.json()

    const potencialError = body as BodyError
    if (potencialError.statusCode !== undefined) {
        throw new ServiceError(potencialError.statusCode, potencialError.message ?? 'Unexpected code')
    }

    if (response.status !== checkStatusCode) {
        throw new ServiceError(response.status, response.statusText)
    }

    return body
}
